const spacer = document.querySelector('.page-title__spacer');

if (spacer) {
  const setNavHeight = () => {
    if (navInner) {
      spacer.style.setProperty('--nav-height', `${navInner.offsetHeight}px`);
    }
  };

  window.addEventListener('resize', debounce(setNavHeight, 200));
  setNavHeight();

  const updateURL = (linkId) => {
    const [currentURL] = window.location.href.split('/#');
    const newURL = `${currentURL}${linkId}`;
    if (window.location.href !== newURL) {
      history.replaceState(null, null, linkId);
    }
  };

  const scrollToSection = (sectionElem) => {
    const { top } = sectionElem.getBoundingClientRect();
    window.scrollTo({
      top: top + window.pageYOffset - getHeaderHeight(),
      behavior: 'smooth',
    });
  };

  // Initialize ScrollTrigger for sections
  const initScrollTriggers = () => {
    const navList = document.querySelector('.page-title__nav-list');

    document.querySelectorAll('.page-title__nav .mod-tag').forEach((link) => {
      const linkId = link.getAttribute('href');

      if (linkId && linkId !== '#') {
        const sectionElem = document.querySelector(linkId.startsWith('http') ? `[href="${linkId}"]` : linkId);

        if (sectionElem) {
          gsap.timeline({
            scrollTrigger: {
              trigger: sectionElem,
              start: 'top center',
              end: 'bottom center',
              scrub: true,
              onToggle: (self) => {
                if (self.isActive) {
                  updateURL(linkId);

                  if (windowWidth() > breakpointMd) {
                    return;
                  }

                  const linkOffsetLeft = link.offsetLeft;
                  const navListWidth = navList.offsetWidth;
                  const linkWidth = link.offsetWidth;
                  const scrollPosition = linkOffsetLeft - navListWidth / 2 + linkWidth / 2;
                  navList.scroll({
                    left: scrollPosition,
                    behavior: 'smooth',
                  });
                }
              },
              toggleClass: { targets: link, className: 'is-active' },
            },
          });
        }
      }
    });
  };

  document.querySelectorAll('.page-title__nav .mod-tag').forEach((link) => {
    const linkId = link.getAttribute('href');

    if (linkId && linkId !== '#') {
      const sectionElem = document.querySelector(linkId.startsWith('http') ? `[href="${linkId}"]` : linkId);

      if (sectionElem) {
        link.addEventListener('click', (ev) => {
          ev.preventDefault();
          scrollToSection(sectionElem);
          updateURL(linkId);
        });
      }
    }
  });

  window.addEventListener('load', initScrollTriggers);
}
